<template>
  <ThemeECommerceContainerSection
    :title="modelValue.title"
    :description="modelValue.description"
    wrapper-class="tw-bg-primary-opacity"
    header-class="tw-mb-6 lg:tw-mb-16"
    event-name=""
    category-event-name=""
  >
    <div
      class="tw-grid tw-grid-cols-1 tw-gap-y-6 lg:tw-grid-cols-3 lg:tw-gap-x-20 lg:tw-gap-y-0"
    >
      <ThemeECommerceCardOverviewProduct
        v-for="item in modelValue.content"
        :key="`overview-product-${item._id}`"
        :image="item.image?.small || ''"
        :title="item.title"
        :description="item.description"
      />
    </div>
  </ThemeECommerceContainerSection>
</template>

<script lang="ts" setup>
defineProps({
  modelValue: {
    type: Object as PropType<HomeSection<OverviewProduct[]>>,
    required: true,
  },
});
</script>
